import { useEffect, useRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ className = "edi-input", id, ...props }) => {
    const [show, setShow] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const form = ref.current?.form;
        if (!form) return undefined;
        const hide = () => setShow(false);
        form.addEventListener("submit", hide);
        return () => form.removeEventListener("submit", hide);
    }, []);
    return (
        <div className="relative">
            <input ref={ref} id={id} {...props} type={show ? "text" : "password"} className={`${className} pr-12`} />
            <button type="button" className="edi-eye-btn" aria-controls={id} aria-pressed={show}
                aria-label={show ? "Nascondi password" : "Mostra password"} onClick={() => setShow((s) => !s)} data-testid={`${id}-visibility-toggle`}>
                {show ? <EyeOff aria-hidden="true" size={20} /> : <Eye aria-hidden="true" size={20} />}
            </button>
        </div>
    );
};
